import { PortalModule } from '@angular/cdk/portal';
import { Inject, NgModule, Optional, SkipSelf } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { DialogBodyModule } from './dialog-body/dialog-body.module';
import { DialogCloseModule } from './dialog-close/dialog-close.module';
import {
  buildDialogConfig,
  DialogConfig,
  DialogConfigOptions,
  DialogRole,
  DialogWidth,
} from './dialog-config';
import {
  DialogContainerAnimationState,
  DialogContainerComponent,
} from './dialog-container/dialog-container.component';
import { DialogFooterModule } from './dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from './dialog-header/dialog-header.module';
import { DialogData, DialogInjector } from './dialog-injector';
import { DialogOpenerService } from './dialog-opener.service';
import { DialogRef } from './dialog-ref';
import { DialogToolbarModule } from './dialog-toolbar/dialog-toolbar.module';
import { DialogComponentI } from './dialog.component';

export function overlayLevelFactory(level: number) {
  return Number.isInteger(level) ? level : 0;
}

@NgModule({
  imports: [
    RtUICommonModule,
    DialogBodyModule,
    DialogCloseModule,
    DialogFooterModule,
    DialogHeaderModule,
    DialogToolbarModule,
    PortalModule,
  ],
  declarations: [DialogContainerComponent],
  providers: [
    {
      provide: 'overlayLevel',
      useFactory: overlayLevelFactory,
      deps: [[new Optional(), new SkipSelf(), new Inject('overlayLevel')]],
    },
  ],
  exports: [
    DialogContainerComponent,
    DialogBodyModule,
    DialogCloseModule,
    DialogFooterModule,
    DialogHeaderModule,
    DialogToolbarModule,
  ],
})
export class RtUIDialogModule {}

export {
  DialogOpenerService,
  DialogRole,
  DialogConfig,
  DialogConfigOptions,
  buildDialogConfig,
  DialogRef,
  DialogData,
  DialogInjector,
  DialogContainerAnimationState,
  DialogContainerComponent,
  DialogComponentI,
  DialogWidth,
};
